import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const ExclamationMarkChatBubbleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M23 12.46L20.56 9.68L20.9 6L17.29 5.18L15.4 2L12 3.46L8.6 2L6.71 5.18L3.1 5.99L3.44 9.67L1 12.46L3.44 15.24L3.1 18.93L6.71 19.75L8.6 22.93L12 21.46L15.4 22.92L17.29 19.74L20.9 18.92L20.56 15.24L23 12.46ZM18.49 14.57L18.75 17.36L16.01 17.98L14.58 20.39L12 19.28L9.42 20.39L7.99 17.98L5.25 17.36L5.51 14.56L3.66 12.46L5.51 10.34L5.25 7.56L7.99 6.95L9.42 4.54L12 5.64L14.58 4.53L16.01 6.94L18.75 7.56L18.49 10.35L20.34 12.46L18.49 14.57ZM11 15.46H13V17.46H11V15.46ZM11 7.46H13V13.46H11V7.46Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
